import "./UwMortalityRates.scss";
import { CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import app from "../../../utils/firebase.js";
import newRequest from "../../../utils/newRequest.js";
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from "@mui/icons-material/Close";
import { FaSave } from "react-icons/fa";
import SearchIcon from "@mui/icons-material/Search";
import BrokenImageOutlinedIcon from '@mui/icons-material/BrokenImageOutlined';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@mui/material";
import { showToast } from "../../../toastService.js";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GridLoader } from "react-spinners";
import { SlArrowDown } from "react-icons/sl";
import { formatStringToNumberV2 } from "../../../utils/genericFunctions.js";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import PublishIcon from "@mui/icons-material/Publish";
import { CustomButton } from "../../../components/ui/CustomButton.jsx";
import Select from "react-select";


const UwMortalityRates = () => {
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [commissionRates, setCommissionRates] = useState([]);

  const [searchTermMortality, setSearchTermMortality] = useState("");
  const [mortalityPage, setMortalityPage] = useState(0);
  const [mortalityTables, setMortalityTables] = useState([]);

  const fetchMortalityTables = async () => {
    try {
      const res = await newRequest.get("/uwMortality/findAll");
      setMortalityTables(res.data);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  useEffect(() => {
    fetchMortalityTables();
  }, []);

  const handleMortalityChangePage = (event, newPage) => {
    setMortalityPage(newPage);
  };

  const handleMortalityChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setMortalityPage(0);
  };

  const handleClearSearchMortality = () => {
    setSearchTermMortality("");
  };

  const filteredMortalityData = mortalityTables.filter(
    (item) =>
      item.mo_name?.toLowerCase().includes(searchTermMortality?.toLowerCase())
  );

  const slicedMortalityData = filteredMortalityData.slice(
    mortalityPage * rowsPerPage,
    mortalityPage * rowsPerPage + rowsPerPage
  );

  // commission rates table
  const [searchTermRates, setSearchTermRates] = useState(""); 
  const [ratesPage, setRatesPage] = useState(0);
  const [rowsPerPageRates, setRowsPerPageRates] = useState(10);
  const [mortalityRates, setMortalityRates] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [selectedRatesRow, setSelectedRatesRow] = useState(null);
  const [selectedMtable, setSelectedMtable] = useState(null);

  const handleAccodionChange = (panel, mtable) => (event, isExpanded) => {
    try {
      setExpanded(isExpanded ? panel : false);
      setSelectedMtable(isExpanded ? mtable : null);
      setMortalityRates(mtable.mo_rates);
    } catch (error) {
      console.log(error)
    }
  };

  const handleRatesChangePage = (event, newPage) => {
    setRatesPage(newPage);
  };

  const handleRatesChangeRowsPerPage = (event) => {
    setRowsPerPageRates(parseInt(event.target.value, 8));
    setRatesPage(0);
  };
 

  // const filteredRatesData = mortalityRates.filter(
  //   (item) =>
  //     item.male?.toLowerCase().includes(searchTermRates?.toLowerCase())
  // );
  const filteredRatesData = mortalityRates;

  const slicedRatesData = filteredRatesData.slice(
    ratesPage * rowsPerPage,
    ratesPage * rowsPerPage + rowsPerPage
  );
 

  const handleRatesChange = (age, gender, field, value) => {
    // Update the corresponding field
    const updatedRates = slicedRatesData.map((rate) => {
      if (rate.age === age) {
        return {
          ...rate,
          [gender]: {
            ...rate[gender],
            [field]: value
          }
        };
      }
      return rate;
    });

    // Assuming you have setRatesData state to hold the updated data
    setMortalityRates(updatedRates);
  };

  const handleRatesBlur = async (moCode, age, gender, field) => {
    try {
      const updatedRate = slicedRatesData.find(rate => rate.age === age);

      if (updatedRate) {
        const value = updatedRate[gender][field];
        // Logic to handle the value, e.g., save it to the backend or run validation
        // console.log(`Saving or validating rate for age: ${age}, gender: ${gender}, field: ${field} with value: ${value}`);
        const res = await newRequest.post("/uwMortality/upd", {
          mo_code: moCode,
          age,
          gender,
          category: field,
          new_rate: value
        });
      }
    } catch (error) {
      console.log(error)
    }
  };


  return (
    <motion.div
      className="mortality-rates"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {slicedMortalityData?.length > 0 &&
        <div className="table-content">
          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
            className="table-container">
            <Table sx={{ width: "max-content", border: 'none' }}>
              <TableBody className="tablebody-accordion">
                {slicedMortalityData?.map((mtable, index) => (
                  <TableRow
                    key={mtable._id}
                    className="tablerow-accordion">
                    <TableCell className="table-cell-accordion"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                      }}>
                      <Accordion className="accordion" expanded={expanded === mtable._id} onChange={handleAccodionChange(mtable._id, mtable)}>
                        <AccordionSummary
                          className="accordion-summary"
                          expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                          id={`panel-${mtable._id}-header`}
                        >
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", marginRight: "50px" }}>
                            <Typography>
                              <span>
                                <span className="sr-no">{mortalityPage * rowsPerPage + index + 1}.</span> <span>{mtable.mo_name}</span>
                              </span>
                            </Typography>
                            <Typography>
                              <span className="account-no">{`CODE : ${mtable.mo_code}`}</span>
                            </Typography>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                          <div className="search">
                            <div className="navbar">
                              {/* <div className="navbar-left">
                                <div className="search-input-wrapper">
                                  <SearchIcon className="search-input-icon" />
                                  <input
                                    className="search-input"
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTermRates}
                                    onChange={(e) => setSearchTermRates(e.target.value)}
                                  />
                                  {searchTermRates.length > 0 && (
                                    <CloseIcon
                                      onClick={handleClearSearchRates}
                                      className="search-input-icon"
                                    />
                                  )}
                                </div>
                              </div> */}
                              <div className="navbar-right">
                                {/* <CustomLoadingButton startIcon={<FaSave />} onClick={saveRecord}>
                                  {savingTitle}
                                </CustomLoadingButton> */}
                              </div>
                            </div>
                          </div>
                          <div className="table-content">
                            <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                              <Table sx={{ width: "max-content", border: 'none' }}>
                                <TableHead className="tablehead">
                                  <TableRow className="tablerow">
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "50px", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>
                                      AGE
                                    </TableCell>
                                    {/* MALE */}
                                    <TableCell className="table-cell male" style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", borderRadius: "5px" }}>
                                      <span>MALE</span>
                                      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                        <TableCell className="table-cell" style={{ flex: "1", justifyContent: "center" }}>
                                          Non Smoker/Drinker
                                        </TableCell>
                                        <TableCell className="table-cell" style={{ flex: "1", justifyContent: "center" }}>
                                          Smoker Only
                                        </TableCell>
                                        <TableCell className="table-cell" style={{ flex: "1", justifyContent: "center" }}>
                                          Drinker Only
                                        </TableCell>
                                        <TableCell className="table-cell" style={{ flex: "1", justifyContent: "center" }}>
                                          Smoker & Drinker
                                        </TableCell>
                                      </div>
                                    </TableCell>
                                    <span style={{ width: "5px" }} />
                                    {/* FEMALE */}
                                    <TableCell className="table-cell female" style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", borderRadius: "5px" }}>
                                      <span >FEMALE</span>
                                      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                        <TableCell className="table-cell" style={{ flex: "1", justifyContent: "center" }}>
                                          Non Smoker/Drinker
                                        </TableCell>
                                        <TableCell className="table-cell" style={{ flex: "1", justifyContent: "center" }}>
                                          Smoker Only
                                        </TableCell>
                                        <TableCell className="table-cell" style={{ flex: "1", justifyContent: "center" }}>
                                          Drinker Only
                                        </TableCell>
                                        <TableCell className="table-cell" style={{ flex: "1", justifyContent: "center" }}>
                                          Smoker & Drinker
                                        </TableCell>
                                      </div>
                                    </TableCell>
                                    <TableCell className="table-cell" style={{ display: "flex", maxWidth: "50px", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>
                                      AGE
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody className="tablebody">
                                  {slicedRatesData?.map((row, index) => (
                                    <TableRow
                                      key={row._id}
                                      className={`${selectedRatesRow?._id === row._id ? "tablerow current" : "tablerow"}`}
                                      onClick={() => {
                                        try {
                                          // console.log(`row  ${JSON.stringify(row, null, 2)}`);
                                          setSelectedRatesRow(row)
                                        } catch (error) {
                                          console.log(error)
                                        }
                                      }}
                                    >
                                      <TableCell className="table-cell" style={{ display: "flex", maxWidth: "50px", alignItems: "center", justifyContent: "center", fontWeight: "bold", fontSize: "18px" }}>
                                        {row.age}
                                      </TableCell>
                                      {/* MALE */}
                                      <TableCell className="table-cell" style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", }}>
                                        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                          <TableCell className="table-cell" style={{ flex: "1", alignItems: "flex-end" }}>
                                            <div className="input-item-with-label">
                                              <input
                                                id="male_nonSmokerNonDrinker"
                                                name="male_nonSmokerNonDrinker"
                                                type="text"
                                                value={row.male.nonSmokerNonDrinker}
                                                style={{ width: "100%", textAlign: "right" }}
                                                className="form-input-item table"
                                                onChange={(e) => handleRatesChange(row.age, 'male', 'nonSmokerNonDrinker', e.target.value)}
                                                onBlur={() => handleRatesBlur(mtable.mo_code, row.age, 'male', 'nonSmokerNonDrinker')}
                                                disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                              />
                                            </div>
                                          </TableCell>
                                          <TableCell className="table-cell" style={{ flex: "1", alignItems: "flex-end" }} >
                                            <div className="input-item-with-label">
                                              <input
                                                id="male_smoker"
                                                name="male_smoker"
                                                type="text"
                                                value={row.male.smoker}
                                                style={{ width: "100%", textAlign: "right" }}
                                                className="form-input-item table"
                                                onChange={(e) => handleRatesChange(row.age, 'male', 'smoker', e.target.value)}
                                                onBlur={() => handleRatesBlur(mtable.mo_code, row.age, 'male', 'smoker')}
                                                disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                              />
                                            </div>
                                          </TableCell>
                                          <TableCell className="table-cell" style={{ flex: "1", alignItems: "flex-end" }} >
                                            <div className="input-item-with-label">
                                              <input
                                                id="male_drinker"
                                                name="male_drinker"
                                                type="text"
                                                value={row.male.drinker}
                                                style={{ width: "100%", textAlign: "right" }}
                                                className="form-input-item table"
                                                onChange={(e) => handleRatesChange(row.age, 'male', 'drinker', e.target.value)}
                                                onBlur={() => handleRatesBlur(mtable.mo_code, row.age, 'male', 'drinker')}
                                                disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                              />
                                            </div>
                                          </TableCell>
                                          <TableCell className="table-cell" style={{ flex: "1", alignItems: "flex-end" }} >
                                            <div className="input-item-with-label">
                                              <input
                                                id="male_smokerDrinker"
                                                name="male_smokerDrinker"
                                                type="text"
                                                value={row.male.smokerDrinker}
                                                style={{ width: "100%", textAlign: "right" }}
                                                className="form-input-item table"
                                                onChange={(e) => handleRatesChange(row.age, 'male', 'smokerDrinker', e.target.value)}
                                                onBlur={() => handleRatesBlur(mtable.mo_code, row.age, 'male', 'smokerDrinker')}
                                                disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                              />
                                            </div>
                                          </TableCell>
                                        </div>
                                      </TableCell>
                                      {/* Separator */}
                                      {/* <TableCell style={{display:"flex", maxWidth: '1px', backgroundColor: '#000', height: '100%' }} /> */}
                                      {/* FEMALE */}
                                      <TableCell className="table-cell" style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", }}>
                                        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                          <TableCell className="table-cell" style={{ flex: "1", alignItems: "flex-end" }}>
                                            <div className="input-item-with-label">
                                              <input
                                                id="female_nonSmokerNonDrinker"
                                                name="female_nonSmokerNonDrinker"
                                                type="text"
                                                value={row.female.nonSmokerNonDrinker}
                                                style={{ width: "100%", textAlign: "right" }}
                                                className="form-input-item table"
                                                onChange={(e) => handleRatesChange(row.age, 'female', 'nonSmokerNonDrinker', e.target.value)}
                                                onBlur={() => handleRatesBlur(mtable.mo_code, row.age, 'female', 'nonSmokerNonDrinker')}
                                                disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                              />
                                            </div>
                                          </TableCell>
                                          <TableCell className="table-cell" style={{ flex: "1", alignItems: "flex-end" }} >
                                            <div className="input-item-with-label">
                                              <input
                                                id="female_smoker"
                                                name="female_smoker"
                                                type="text"
                                                value={row.female.smoker}
                                                style={{ width: "100%", textAlign: "right" }}
                                                className="form-input-item table"
                                                onChange={(e) => handleRatesChange(row.age, 'female', 'smoker', e.target.value)}
                                                onBlur={() => handleRatesBlur(mtable.mo_code, row.age, 'female', 'smoker')}
                                                disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                              />
                                            </div>
                                          </TableCell>
                                          <TableCell className="table-cell" style={{ flex: "1", alignItems: "flex-end" }} >
                                            <div className="input-item-with-label">
                                              <input
                                                id="female_drinker"
                                                name="female_drinker"
                                                type="text"
                                                value={row.female.drinker}
                                                style={{ width: "100%", textAlign: "right" }}
                                                className="form-input-item table"
                                                onChange={(e) => handleRatesChange(row.age, 'female', 'drinker', e.target.value)}
                                                onBlur={() => handleRatesBlur(mtable.mo_code, row.age, 'female', 'drinker')}
                                                disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                              />
                                            </div>
                                          </TableCell>
                                          <TableCell className="table-cell" style={{ flex: "1", alignItems: "flex-end" }} >
                                            <div className="input-item-with-label">
                                              <input
                                                id="female_smokerDrinker"
                                                name="female_smokerDrinker"
                                                type="text"
                                                value={row.female.smokerDrinker}
                                                style={{ width: "100%", textAlign: "right" }}
                                                className="form-input-item table"
                                                onChange={(e) => handleRatesChange(row.age, 'female', 'smokerDrinker', e.target.value)}
                                                onBlur={() => handleRatesBlur(mtable.mo_code, row.age, 'female', 'smokerDrinker')}
                                                disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                              />
                                            </div>
                                          </TableCell>
                                        </div>
                                      </TableCell>
                                      <TableCell className="table-cell" style={{ display: "flex", maxWidth: "50px", alignItems: "center", justifyContent: "center", fontWeight: "bold", fontSize: "18px" }}>
                                        {row.age}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                              <TablePagination
                                rowsPerPageOptions={[10]}
                                rowsPerPage={rowsPerPageRates}
                                onRowsPerPageChange={handleRatesChangeRowsPerPage}
                                component="div"
                                count={filteredRatesData.length}
                                page={ratesPage}
                                onPageChange={handleRatesChangePage}
                              />
                            </TableContainer>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10]}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleMortalityChangeRowsPerPage}
              component="div"
              count={filteredMortalityData.length}
              page={mortalityPage}
              onPageChange={handleMortalityChangePage}
            />
          </TableContainer>
        </div>
      }
      {
        isProcessing && (
          <motion.div
            className="processing-dialog"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            <div className="processing-wrapper">
              <GridLoader
                color="#bd97fc"
                style={{
                  height: "50px",
                  width: "50px",
                }}
              />
            </div>
          </motion.div>
        )
      }
    </motion.div>
  );
};

export default UwMortalityRates;
